import { checkDomainAllowFetchDataConfig } from 'components/common/func';
import { checkMaintenance } from 'helpers/maintenance';
import useFxAddTransaction from 'hooks/fx/useFxAddTransaction';
import useAuth from 'hooks/useAuth';
import useCommonStore from 'hooks/useCommonStore';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';

const withRefreshFXRates = (Component) => {
  const RefreshFXRatesComponent = (props) => {
    const { setLoading } = useCommonStore();
    const { getAllFXRates } = useFxAddTransaction();
    const { isAuthenticated } = useAuth();

    const [allFxRates, setAllFxRates] = useState(null);

    const fetchAllFxRates = async () => {
      setLoading(true);
      try {
        getAllFXRates(setAllFxRates);
      } catch (error) {
        setLoading(false);
        checkMaintenance(error);
        console.error(error?.message);
        ƒ;
      }
    };

    useEffect(() => {
      if (!checkDomainAllowFetchDataConfig()) return;
      if (!isAuthenticated) return;
      if (isEmpty(allFxRates)) {
        fetchAllFxRates();
      }
    }, [isAuthenticated, allFxRates]);

    useEffect(() => {
      if (!checkDomainAllowFetchDataConfig()) return;
      if (!isAuthenticated) return;
      const interval = setInterval(fetchAllFxRates, 600000);
      return () => clearInterval(interval);
    }, [isAuthenticated]);

    const newProps = {
      ...props,
      allFxRates,
    };
    return <Component {...newProps} />;
  };
  return RefreshFXRatesComponent;
};

export default withRefreshFXRates;
